import Header from './components/Header'
import './App.css';
import Meme from './components/Meme'

function App() {
  return (
    <div className=''>
    <Header />
    <Meme />
    </div>
  );
}

export default App;
